export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YLJvilUs6yLUrwB0lw.4d5dea41.woff2";